var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenpocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2980FE;}\n\t.st1{opacity:0.6;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    className: "st0",
    width: 1024,
    height: 1024
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.1,389.7h-19.1V253.3h-252c-4.8,0-8.7,3.9-8.7,8.7v192.3l0,0l0,0c0,4.8,3.9,8.7,8.7,8.7h96.2v349.7l0,0 l0,0c0,4.8,3.9,8.7,8.7,8.7h0l0,0h157.4c4.8,0,8.7-3.9,8.7-8.7l0,0l0,0V389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M630.8,201.5h-60.5l0,0H404.2l0,0c-4.8,0-8.7,3.9-8.7,8.7V761l0,0l0,0c0,4.8,3.9,8.7,8.7,8.7l0,0h157.4 c0,0,0,0,0,0c4.8,0,8.7-3.9,8.7-8.7V621.1h60.5c115.9,0,209.8-93.9,209.8-209.8C840.6,295.4,746.7,201.5,630.8,201.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenpocket);
export default __webpack_public_path__ + "static/media/tokenpocket.e5664c049b04bb685541aaccce29220c.svg";
export { ForwardRef as ReactComponent };